import React from 'react'
import { ErrorMessage, Field, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import NumberFormat from 'react-number-format'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  categoryType,
  onChangeIsGradeTwo,
  index,
  data
}) => (
  <fieldset className="fieldset blue-fieldset">
    <legend>کالای درجه سه (انبار محصولات)</legend>
    <div className="row">
      <div className="col-lg-12 col-sm-12">
        <FormControlLabel
          control={
            <Checkbox
              size="medium"
              checked={values.items[index].selectFromList}
              onChange={e => {
                setFieldValue(
                  `items[${index}][selectFromList]`,
                  e.target.checked
                )
                if (!e.target.checked) {
                  setFieldValue(
                    `items[${index}][id]`,
                    '00000000-0000-0000-0000-000000000000'
                  )
                }
              }}
              name="selectFromList"
              color="primary"
            />
          }
          label="انتخاب از لیست"
        />
      </div>
      {values.items[index].selectFromList ? (
        <div className="form-inline">
          <div className="col-lg-6 col-sm-12">
            <AsyncProductSelect
              brandId={values.items[index].brandId}
              // categoryType={values.relatedProducts.filter(el => el.unitType === 7 && el.relatedProductType === 0)[0].categoryType}
              categoryId={values.items[index].categoryId}
              defaultValue={values.items[index].relatedProductId}
              onChange={val => {
                setFieldValue(`items[${index}][relatedProductId]`, val.value)
              }}
              className={
                getIn(errors, `items[${index}].relatedProductId`)
                  ? 'semantic-select-box has-error'
                  : 'semantic-select-box'
              }
            />
            <ErrorMessage
              component={ErrorPopUp}
              name={`items[${index}].relatedProductId`}
            />
          </div>
        </div>
      ) : (
        <div className="form-inline">
          {/* {JSON.stringify(data)} */}
          <div className="col-md-6">
            <label>نام کالا</label>
            <input
              type="text"
              value={values.items[index].name}
              onBlur={handleBlur}
              name="name"
              // autoFocus
              onChange={e => {
                setFieldValue(`items[${index}][name]`, e.target.value)
              }}
              className={
                getIn(errors, `items[${index}].name`)
                  ? 'text-input has-error'
                  : 'text-input'
              }
            />
            {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].name`} /> */}
          </div>

          <div className="col-md-2">
            <label>کد کالا</label>
            <Field
              type="text"
              value={values.items[index].extraCode}
              name="extraCode"
              onChange={e => {
                setFieldValue(`items[${index}][extraCode]`, e.target.value)
              }}
              onBlur={handleBlur}
              className={
                getIn(errors, `items[${index}].extraCode`)
                  ? 'text-input bold has-error'
                  : 'text-input bold'
              }
            />
            {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].extraCode`} /> */}
          </div>

          <div className="col-md-2">
            <label>دسته بندی</label>
            <AsyncCategorySelect
              onlyThirdaryClass={true}
              categoryType={categoryType}
              defaultValue={values.items[index].categoryId}
              name="categoryId"
              onChange={(val, measurementType) => {
                setFieldValue(`items[${index}][categoryId]`, val)
                setFieldValue(
                  `items[${measurementType}][categoryId]`,
                  measurementType
                )
              }}
              className={
                getIn(errors, `items[${index}].categoryId`)
                  ? 'semantic-select-box has-error'
                  : 'semantic-select-box'
              }
            />
            {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].categoryId`} /> */}
          </div>
        </div>
      )}
    </div>
  </fieldset>
)
